/**
 * Modals Module
 *
 */
import { Navigation } from './Navigation.js';
import { Constants } from '../helpers/constants.js';
//import { HomeModal } from '../../Components/Modals/HomeModal/HomeModal.js';

//------------------------------------------------------------------------------------------------------------------
// ::: CONSTANTS
//------------------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------------------
// ::: PUBLIC VARIABLES
//------------------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------------------
// ::: PRIVATE VARIABLES
//------------------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------------------
// ::: GETTERS & SETTERS
//------------------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------------------
// ::: PUBLIC FUNCTIONS
//------------------------------------------------------------------------------------------------------------------

const Modals = {
    init: function (e) {
        var scrollerModal,
            externalLink,
            modal,
            scrollTop,
            isiHeight,
            newHeight;

        Modals.bindEvents();
    },

    bindEvents: function (e) {
        const modalOpenSelectors = [
            '.designModal',
            '.publicationModal',
            '.interstitialModal',
            '.orglink a'
        ];
        $(modalOpenSelectors.join(', ')).on('click', Modals.events.open);
        $('.btnOK').on('click', Modals.events.external);
        $('.btnReturn, .modalClose').on('click', Modals.events.close);
    },

    events: {
        position: function () {
            let margin = 0;

            Modals.init.newHeight = $(window).height() * 0.75;

            console.log("modals.init.modal", Modals.init.modal );

            if (Modals.init.modal.search('interstitial') === -1) {
                console.log('IS NOT interstitial');
                margin = ($(window).height() * 0.25) / 2;
                $('#' + Modals.init.modal + ' .modalContent').height(Modals.init.newHeight).css('margin-top', margin);

            } else {
                console.log('IS interstitial');

                $('.DefaultInterstitial .modalContent, #interstitial').css({
                    'height': 'auto'
                }).css({
                    'margin-top': Math.max((($(window).height() - $('#' + Modals.init.modal + ' .modalContent').innerHeight()) / 2) - 40, 0)
                });
            }

            setTimeout(function () {
                if (Modals.init.scrollerModal) {
                    Modals.init.scrollerModal.refresh();
                }
            }, 0);
        },

        open: function (e) {
            e.preventDefault();
            Modals.init.modal = $(this).data('id');
            Modals.init.externalLink = $(this).attr('href');
            $('#' + Modals.init.modal).addClass('on');

            if (Navigation.vars.isMobile) {
                Modals.init.scrollTop = $(window).scrollTop();
                $('body,html').addClass('noscroll');
            }

            $(window).on('resize', Modals.events.position);
            Modals.events.position();

            setTimeout(function () {
                Modals.init.scrollerModal = new IScroll('#' + Modals.init.modal + ' .modalBody', {
                    disablePointer: false,
                    disableTouch: false,
                    disableMouse: false,
                    mouseWheel: true,
                    bounce: false,
                    click: true,
                    scrollbars: 'custom',
                    interactiveScrollbars: true
                });
            }, 50);

            //account for lazy loading
            $('#' + Modals.init.modal + ' img').on('load', function () {
                if (Modals.init.scrollerModal) {
                    Modals.init.scrollerModal.refresh();
                }
            });
        },

        external: function (e) {
            const ele = $(e.target).parents('.modal').attr('id');

            if (!Constants.isIE) {
                setTimeout(function () {
                    $('#' + ele).removeClass('on');
                    if (Navigation.vars.isMobile) {
                        $('body,html').removeClass('noscroll');
                    }
                    if (Modals.init.scrollerModal) {
                        Modals.init.scrollerModal.destroy();
                    }
                    Modals.init.scrollerModal = null;
                    window.open(Modals.init.externalLink);
                }, 0);

            } else {
                $('#' + ele).removeClass('on');
                if (Navigation.vars.isMobile) {
                    $('body,html').removeClass('noscroll');
                }
                if (Modals.init.scrollerModal) {
                    Modals.init.scrollerModal.destroy();
                }
                Modals.init.scrollerModal = null;
                window.open(Modals.init.externalLink);
            }
        },

        close: function (e) {
            const ele = $(this).data('id');

            setTimeout(function () {
                $('#' + ele).removeClass('on');

                if (Navigation.vars.isMobile) {
                    $('body,html').removeClass('noscroll');
                    window.scrollTo(0, Modals.init.scrollTop);
                }

                if (Modals.init.scrollerModal) {
                    Modals.init.scrollerModal.destroy();
                }

                Modals.init.scrollerModal = null;

                $(window).off('resize', Modals.events.position);
            }, 200);
        }
    },
};


//------------------------------------------------------------------------------------------------------------------
// ::: PRIVATE FUNCTIONS
//------------------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------------------
// ::: CALLBACKS & EVENT HANDLERS
//------------------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------------------
// ::: API
//------------------------------------------------------------------------------------------------------------------


export {
    Modals,
    //HomeModal,
};
